<template lang="pug">
  el-row#placeholder-container-admin(
    :class="[questionData.isSelected  ? 'placeholder-selected': 'placeholder-normal']"
   )
    el-row(
      @mouseover.native="isHover=true"
      @mouseleave.native="isHover=false"
    ) 
      // Question Header
      div#question-header 
        el-col#question-text(:span="20") 
          img#question-type-icon(:src="typeIcon")
          span {{ questionData.title }}
      
        el-col(v-if="questionData.score>0" :span="4") 
          div#score-text {{ questionData.score + ' ' }}
            span(v-if="questionData.score>=2") pts
            span(v-else) pt
      
      // Question Text
      div#placeholder-content(v-html="questionData.text" style="margin-top: 20px;")

      // Question Custom Content
      component(
        :is="previewType"
        :questionData="{ ...questionData.fields, correct_answer: questionData.correct_answer }"
        :contentVisible="showPreview"
      )

    el-col(:span="24" v-if="showTags")
      el-tag#question-tag-button(
        key="tag_label"
        type="success"
      ) Tags:
      el-tag#question-tag-button(
        style="color: var(--darkest-blue);"
        v-for="tag in questionData.activeTags"
        :key="tag"
        type="info") {{tag}}
</template>

<script>
import AnswerInputPreview from "@/components/demo/preview/AnswerInputPreview";
import CodingPreview from "@/components/demo/preview/CodingPreview";
import { QUESTION_TYPES } from "@/defines/constants";

export default {
  name: "QuestionPreview",

  components: {
    AnswerInputPreview,
    CodingPreview
  },

  props: {
    id: {
      type: Number,
      required: true
    },

    questionData: {
      type: Object,
      required: true
    },

    showPreview: {
      type: Boolean,
      required: true
    },

    selectOnly: {
      type: Boolean,
      required: true
    },

    superAccess: {
      type: Boolean,
      default: false
    },

    showTags: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      visible: "visible",
      isHover: false,
      content: "",
      newTag: "",
      isTagInputVisible: false,
      firstLoaded: true,
      typeIcon: null,

      previewTypes: ["None", "AnswerInputPreview", "CodingPreview"]
    };
  },

  computed: {
    previewType() {
      return this.previewTypes[this.questionData.type_id];
    }
  },

  watch: {
    questionData() {
      const typeKey = Object.keys(QUESTION_TYPES).find(
        key => QUESTION_TYPES[key] === this.questionData.type_id
      );
      this.typeIcon = require(`@/assets/icons/${typeKey}_icon.svg`);
    }
  },

  mounted() {
    this.firstLoaded = false;
    const typeKey = Object.keys(QUESTION_TYPES).find(
      key => QUESTION_TYPES[key] === this.questionData.type_id
    );
    this.typeIcon = require(`@/assets/icons/${typeKey}_icon.svg`);
  },

  methods: {
    hide() {
      this.$msgbox({
        title: "Delete Question",
        message:
          "Do you want to delete <strong>" +
          this.questionData.title +
          "</strong>?",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        dangerouslyUseHTMLString: true,
        confirmButtonClass: "delete-button"
      })
        .then(() => {
          this.$emit("hideItem", this.id);
        })
        .catch(() => {});
    }
  }
};
</script>

<style>
#placeholder-container-admin {
  margin: 0% 2%;
  border-radius: 7px;
  margin-top: 1em;
  padding: 0em 1em 1em;
  height: auto;
}

#placeholder-container-admin:hover {
  background-color: #e3f2fd;
  border: 1px dotted var(--button-blue);
  cursor: pointer;
}

.placeholder-normal {
  border: 1px solid #b0b2b5;
  background-color: #fff;
}

.placeholder-selected {
  background-color: #f0f9eb;
  border: 1px dotted var(--purple-blue);
}

#question-header {
  min-height: 40px;
  font-size: 16px;
  font-weight: bold;
  margin-top: 20px;
}

#question-text {
  padding-left: 25px;
  font-size: 1.1em;
  line-height: 1.25em;
  color: var(--purple-blue);
  vertical-align: center;
}

#score-text {
  margin-right: 20px;
  float: right;
}

#placeholder-content {
  margin: 10px 30px 30px 30px;
  font-size: 1em;
}

#placeholder-content p {
  color: var(--text-gray) !important;
}

#question-edit-buttons {
  float: right;
  margin: 0px 10px 10px 20px;
}

#question-tag-select {
  font-size: 12px;
  height: 32px;
  width: 100px;
  margin-left: 5px;
  margin-bottom: 5px;
}

#question-tag-button {
  margin-left: 5px;
  margin-bottom: 5px;
}

#question-type-icon {
  width: 30px;
  height: 30px;
  padding-right: 15px;
  vertical-align: text-bottom;
}
</style>
